import { useState } from 'react';
import RegistrationModal from '../../../components/feature/RegistrationModal';

export default function Tournaments() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  const tournaments = [
    {
      name: 'Weekly Clash',
      date: 'Every Friday',
      prize: '$500',
      participants: '64 players',
      status: 'Open',
      difficulty: 'All Levels'
    },
    {
      name: 'Monthly Championship',
      date: 'Dec 15, 2024',
      prize: '$2,000',
      participants: '128 players',
      status: 'Registration Open',
      difficulty: 'Advanced'
    },
    {
      name: 'Beginner Cup',
      date: 'Dec 8, 2024',
      prize: '$200',
      participants: '32 players',
      status: 'Open',
      difficulty: 'Beginner'
    }
  ];

  return (
    <>
      <section id="tournaments" className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Upcoming Tournaments
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Compete against the best players and climb the rankings
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {tournaments.map((tournament, index) => (
              <div key={index} className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-purple-600 transition-all">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-bold text-white">{tournament.name}</h3>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    tournament.status === 'Open' ? 'bg-green-600 text-white' : 'bg-purple-600 text-white'
                  }`}>
                    {tournament.status}
                  </span>
                </div>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-gray-400">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>{tournament.date}</span>
                  </div>
                  <div className="flex items-center text-gray-400">
                    <i className="ri-trophy-line mr-2"></i>
                    <span>{tournament.prize} Prize Pool</span>
                  </div>
                  <div className="flex items-center text-gray-400">
                    <i className="ri-group-line mr-2"></i>
                    <span>{tournament.participants}</span>
                  </div>
                  <div className="flex items-center text-gray-400">
                    <i className="ri-star-line mr-2"></i>
                    <span>{tournament.difficulty}</span>
                  </div>
                </div>

                <div className="p-6">
                  <button 
                    onClick={() => setIsRegistrationOpen(true)}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Register Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <RegistrationModal 
        isOpen={isRegistrationOpen} 
        onClose={() => setIsRegistrationOpen(false)} 
      />
    </>
  );
}
